import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef, MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { EvaluadosDto } from 'src/app/dto/evaluados-dto';
import { RespuestaEvaluadoComponent } from '../respuesta-evaluado/respuesta-evaluado.component';

@Component({
  selector: 'app-evaluados',
  templateUrl: './evaluados.component.html',
  styleUrls: ['./evaluados.component.css']
})
export class EvaluadosComponent implements OnInit {

  public load: boolean;
  array: EvaluadosDto[] = [];
  evaluados: EvaluadosDto[] = [];
  DocentesEvaluados: EvaluadosDto[] = [];
  mostrar = false;
  displayedColumns: string[] = ['Cursos', 'Docentes'];
  dataSource = new MatTableDataSource<EvaluadosDto>([]);

  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;

  constructor(private dialogRef: MatDialogRef<EvaluadosComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, public dialog: MatDialog,) { this.load = false; }

  ngOnInit() {
    this.adjustDialogSize();
    this.evaluados = this.data.Listaevaluados;
    this.DocentesEvaluados = this.data.Evaluados;

    if (this.evaluados != null || this.DocentesEvaluados != null) {
      this.mostrar = true;
    }

    setTimeout(() => {
      this.load = true;
    }, 1000);
  }

  private adjustDialogSize() {
    if (window.innerWidth < 768) {
      this.dialogRef.updateSize('95%', '90%');
    } else {
      this.dialogRef.updateSize('80%', '80%');
    }
  }

  DialogRespuestas(docente: any, curso: any) {
    const dialogRef = this.dialog.open(RespuestaEvaluadoComponent, {
      maxWidth: '100vw',
      maxHeight: '100vh',
      data: {
        Listaevaluados: this.data.Listaevaluados,
        Evaluados: this.data.Evaluados,
        evaluadoDocente: docente,
        evaluadoCurso: curso
      },
    });

    dialogRef.afterClosed().subscribe(result => { });
  }

  DialogRespuestasDocente(docente: any) {
    const dialogRef = this.dialog.open(RespuestaEvaluadoComponent, {
      maxWidth: '100vw',
      maxHeight: '100vh',
      data: {
        Listaevaluados: this.data.Listaevaluados,
        Evaluados: this.data.Evaluados,
        evaluadoDocente: docente
      },
    });

    dialogRef.afterClosed().subscribe(result => { });
  }

}
